import axios from 'axios'

const AxiosInstance = axios.create({
//baseURL: 'http://localhost:3002',
baseURL : "http://auditapi.iqcpl.in",
//baseURL: 'http://auditapi.gpiso.com',
//baseURL: 'http://testauditapi.iqcpl.in',
    timeout: 5000,
    // headers: {'X-Custom-Header': 'foobar'}
  });

//export const REACTURL = "http://localhost:3000";
//export const APIURL="http://api.gpiso.com";
//export const APIURL="http://localhost:3002";
export const APIURL="http://auditapi.iqcpl.in";
//export const APIURL="http://auditapi.gpiso.com";
//export const APIURL = 'http://testauditapi.iqcpl.in';
//export const APIURL="http://localhost:3000";

export default AxiosInstance